import { GridRowParams } from "@mui/x-data-grid";

export const getIncidentRowClassName = (
  params: GridRowParams,
  highlightedIncidentId?: string | null,
) => {
  const rowClasses = [];

  if (params.row.incidentStatus === "notStarted") {
    rowClasses.push("not-started");
  } else if (params.row.incidentStatus === "pending") {
    rowClasses.push("pending");
  } else if (params.row.incidentStatus === "completed") {
    rowClasses.push("completed");
  } else if (params.row.incidentStatus === "onHold") {
    rowClasses.push("on-hold");
  } else if (params.row.incidentStatus === "waitingForInvoice") {
    rowClasses.push("waiting-for-invoice");
  }
  rowClasses.push("waiting-for-invoice");

  if (highlightedIncidentId && params.row.id === highlightedIncidentId) {
    rowClasses.push("last-opened-incident");
  }

  return rowClasses.join(" ");
};

export const getRepairRowClassName = (params: GridRowParams) => {
  if (params.row.repairStatus === "notStarted") {
    return "not-started";
  } else if (params.row.repairStatus === "pending") {
    return "pending";
  } else if (params.row.repairStatus === "completed") {
    return "completed";
  } else if (params.row.repairStatus === "onHold") {
    return "on-hold";
  } else if (params.row.repairStatus === "waitingForInvoice") {
    return "waiting-for-invoice";
  }
  return "";
};
